import { css, LinearProgress, styled } from '@mui/material';

import { ProgressbarProps } from './types';

export const SProgressbar = styled(LinearProgress)<ProgressbarProps>(
  ({ size, theme }) => css`
    flex-grow: 1;
    height: 8px;
    border-radius: 4px;
    background-color: ${theme.palette.grey[200]};

    .MuiLinearProgress-barColorPrimary {
      background-color: ${theme.palette.primary[600]};
      border-radius: 6px;
    }

    ${size === 'xs' &&
    css`
      height: 2px;
      border-radius: 0;
    `}

    ${size === 'sm' &&
    css`
      height: 4px;
      border-radius: 0;
    `}

    ${size === 'md' &&
    css`
      height: 12px;
      border-radius: 10px;
    `}
  `,
);
